module.exports = __webpack_public_path__ + "img/lookup3.377920e6.png";